export const LOAD_PAID_CASH_REQUESTS = "LOAD_PAID_CASH_REQUESTS"
export const loadPaidCashRequestsAction = cashRequestsPagination => ({
   type: LOAD_PAID_CASH_REQUESTS,
   payload: cashRequestsPagination
})